module.exports = __webpack_public_path__ + "media/images/partner/baselstadt-medizinische-dienste-c2d3f2b5956f7547298e7b4b004da16d.png";